import axios from 'axios';
import { createBrowserHistory } from 'history';
import apiUrls from './apiUrls';
import { APP_ID, CHANNEL, DEVICE_ID, FRONT_END_NAME, OPERATOR, parseObjectBeforeGet } from './constants';

const history = createBrowserHistory();
axios.interceptors.response.use(function (response) {
   
     if(response.data.code == 4001){
       console.log("auth error");
        return window.location = FRONT_END_NAME+'/?err=1';
     }
     if(response.data.code == 5003){
        //return window.location = '/login?err=2';
     }
    return response;
  }, function (error) {
   
    return Promise.reject(error);
  });


export const getPostApi =   (url, headers = {}, requestBody={} ) => {
    console.log("Url to call : ", url);
    console.log("headers : ", headers)
    console.log("requestBody : ", requestBody);
    return axios.post(url, requestBody, {headers} );
}

export const getGetApi = (url, headers = {}) => {
    console.log("Url to call : ", url);
    headers["Content-Type"]="application/json";
    console.log("headers : ", headers);
    return axios.get(url,{headers});
}

function getLoginSession () {
  

    var userData = parseObjectBeforeGet("userdata");
    console.log("userdata",userData);
    return userData.profilerData.user;
  

}

export function registerPlayerCount(contentId){
  console.log("contentid",contentId);
    getGetApi("http://103.115.212.7:4423/bcms/updateMetadataAPI.do?metaDataName=TotalPlayCounts&contentName="+contentId,{}).then((response)=>{
        console.log("response",response);
    })
}


export function saveAccessLogs(content, category, subCategory) {
  debugger;
  if(sessionStorage["minutePending"]!= "" && sessionStorage["minutePending"] != undefined){
    let dateStored = new Date(sessionStorage["minutePending"]);
    var current = new Date();
    var minutes = (current - dateStored)/60000;
    if(minutes>30){}
    else{
      return;
    }
  }
  sessionStorage["minutePending"] = new Date();
  const headers = {
    'Content-Type': 'application/json',
    'appid': "1",
    'operator': OPERATOR,
    'msisdn': getLoginSession().username,
    'channel': CHANNEL
  };

  const requestBody = {
    "category": category,
    "subCategory": subCategory,
    "content": content,
    "url": window.location.pathname,
    "packname": "",
    "sessionid": getDeviceId(),
    "appname": FRONT_END_NAME == "" ? "/healthportal" : FRONT_END_NAME
  }

  getPostApi(apiUrls.saveLogs, headers, requestBody).then((response) => {
    console.log("response",response);
  })

}

export function getDeviceId(force){
  if(force || (typeof sessionStorage["DeviceId"] == 'undefined' || sessionStorage['DeviceId'] == '')){
    sessionStorage["DeviceId"] = generateDeviceId();
  }
  return sessionStorage["DeviceId"];
}

function generateDeviceId(){
  var navigator_info = window.navigator;
  var screen_info = window.screen;
  var uid = navigator_info.mimeTypes.length;
  uid += navigator_info.userAgent.replace(/\D+/g, '');
  uid += navigator_info.plugins.length;
  uid += screen_info.height || '';
  uid += screen_info.width || '';
  uid += screen_info.pixelDepth || '';
  //console.log(uid);
  return uid.toString();
}

export const getContentHeaders = () =>  {
  return {
    'Content-Type':'application/json',
    'appid':APP_ID,
    'channel':CHANNEL,
    'deviceId': DEVICE_ID,
    'Msisdn':getLoginSession().username,
    'operator':OPERATOR,
    'Access_token': getLoginSession().accessToken
  }
}